// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.LoginPage_loginContainer__tAEFn {
  margin: auto 0;
  height: 100%;
  justify-items: center;
  justify-content: center;
}

.LoginPage_loginForm__W2HTR {
  max-width: 300px;
  padding: 20px;
  border: 1px solid #ccc;
  border-radius: 5px;
  position: absolute;
  top: 40%;
  left: 50%;
  transform: translate(-50%, -50%);
}

.LoginPage_loginHeader__qn5Go {
  text-align: center;
}

.LoginPage_loginInput__5LyeI {
  width: 100%;
  padding: 8px;
  margin: 10px 0;
}

.LoginPage_myButton__ok5NI {
  width: 100%;
  padding: 10px;
  background-color: #333;
  color: #fff;
  border: none;
  cursor: pointer;
}
.LoginPage_myButton__ok5NI:hover {
  background-color: #555;
}

.LoginPage_error__87JH- {
  color: red;
  text-align: center;
}`, "",{"version":3,"sources":["webpack://./src/pages/Login/LoginPage.module.scss"],"names":[],"mappings":"AAAA;EACE,cAAA;EACA,YAAA;EACA,qBAAA;EACA,uBAAA;AACF;;AAEA;EACE,gBAAA;EACA,aAAA;EACA,sBAAA;EACA,kBAAA;EACA,kBAAA;EACA,QAAA;EACA,SAAA;EACA,gCAAA;AACF;;AAEA;EACE,kBAAA;AACF;;AAEA;EACE,WAAA;EACA,YAAA;EACA,cAAA;AACF;;AAEA;EACE,WAAA;EACA,aAAA;EACA,sBAAA;EACA,WAAA;EACA,YAAA;EACA,eAAA;AACF;AACE;EACE,sBAAA;AACJ;;AAGA;EACE,UAAA;EACA,kBAAA;AAAF","sourcesContent":[".loginContainer {\n  margin: auto 0;\n  height: 100%;\n  justify-items: center;\n  justify-content: center;\n}\n\n.loginForm {\n  max-width: 300px;\n  padding: 20px;\n  border: 1px solid #ccc;\n  border-radius: 5px;\n  position: absolute;\n  top: 40%;\n  left: 50%;\n  transform: translate(-50%, -50%);\n}\n\n.loginHeader {\n  text-align: center;\n}\n\n.loginInput {\n  width: 100%;\n  padding: 8px;\n  margin: 10px 0;\n}\n\n.myButton {\n  width: 100%;\n  padding: 10px;\n  background-color: #333;\n  color: #fff;\n  border: none;\n  cursor: pointer;\n\n  &:hover {\n    background-color: #555;\n  }\n}\n\n.error {\n  color: red;\n  text-align: center;\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"loginContainer": `LoginPage_loginContainer__tAEFn`,
	"loginForm": `LoginPage_loginForm__W2HTR`,
	"loginHeader": `LoginPage_loginHeader__qn5Go`,
	"loginInput": `LoginPage_loginInput__5LyeI`,
	"myButton": `LoginPage_myButton__ok5NI`,
	"error": `LoginPage_error__87JH-`
};
export default ___CSS_LOADER_EXPORT___;
